import React from 'react'
import { useMutation } from '@apollo/client'
import { Button } from '@/atoms/Button'
import { paths } from '@/constants/paths'
import { slugs } from '@/constants/slugs'
import {
  COMPLETE_NFT_PACK_WALLET_PURCHASE,
  COMPLETE_NFT_TRANSFER_WALLET_PURCHASE,
  CONFIRM_ANGEL_CHECKOUT_MUTATION,
} from '@/services/NftService'
import { useSafeTrack } from '@/utils/analytics'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

interface WalletPaymentMethodProps {
  isPackPurchase: boolean
  isTradePurchase: boolean
  isPurchaseOfferPurchase: boolean
  offerId?: number
  dropId?: number
  listingId?: number
  orderId?: string
  purchaseOfferId?: string
  projectId: string
  isPaymentState: boolean
  changeAddressCheckoutState: () => void
  onClose?: () => void
}

const WalletPaymentMethod: React.FC<WalletPaymentMethodProps> = ({
  isPackPurchase,
  isTradePurchase,
  offerId,
  dropId,
  listingId,
  isPaymentState,
  orderId,
  onClose,
  projectId,
}) => {
  const router = useSafeRouter()
  const track = useSafeTrack()

  const [completeNFTPackPurchase, { loading }] = useMutation(
    isPackPurchase
      ? COMPLETE_NFT_PACK_WALLET_PURCHASE
      : isTradePurchase
      ? COMPLETE_NFT_TRANSFER_WALLET_PURCHASE
      : CONFIRM_ANGEL_CHECKOUT_MUTATION,
    {
      onCompleted: (data) => {
        const status =
          data?.completeNFTPackWalletPurchase?.status ||
          data?.completeNFTTransferWalletPurchase?.status ||
          data?.confirmAngelCheckout?.success

        if (status === 'success' || status) {
          router.push(`${paths.collectibles.success(projectId)}?order=${orderId}`)
        }
        onClose?.()
      },
      errorPolicy: 'all',
    },
  )

  const handleCompletePurchase = () => {
    completeNFTPackPurchase({
      variables: isPackPurchase
        ? {
            input: {
              offerId,
              dropId,
            },
          }
        : isTradePurchase
        ? {
            listingId,
          }
        : {
            input: {
              orderId,
            },
          },
    })

    track('Scene Pack Complete Purchase Clicked', {
      purchaseMethod: 'wallet-credit',
      projectSlug: projectId,
    })
  }

  return (
    <div className="w-full">
      <div className="flex flex-row gap-10 w-full sm:w-fit">
        {loading ? (
          <div className="text-black rounded-lg border-black w-full px-6 py-3 border">Processing...</div>
        ) : (
          <Button
            className="text-black bg-core-oxide border-none w-full py-3"
            variant="oxide"
            disabled={!isPaymentState || loading}
            id="submit"
            type="submit"
            onClick={handleCompletePurchase}
          >
            Complete Purchase
          </Button>
        )}
      </div>
    </div>
  )
}

export default WalletPaymentMethod
